<template>
  <v-toolbar :color="hasSelectedItems ? 'rgba(17, 138, 202, 0.1)' : undefined" elevation="0" style="border-radius: 8px;">
    <v-checkbox
      @change="handleFaturamentoCheckboxClick"
      :value="selectedAll"
      :indeterminate="indeterminate"
      :disabled="disabled"
      :label="label"
      color="primary"
      hide-details
    />
    <v-col v-if="hasSelectedItems" class="d-flex align-center" cols="9">
      <v-col cols="4" style="padding-left: 0">
        <div class="primary--text">{{ selectedFaturamentoLotesCount | pluralize }} de {{ totalFaturamentoLotes }}</div>
      </v-col>
      <v-row>
        <v-col cols="6">
          <div>
            <b>Cronogramas:</b>
            <br/>
            {{ cronogramas }}
          </div>
        </v-col>

        <v-col cols="2">
          <div>
            <b>Pendente:</b>
            <br/>
            {{ totalPendente | formatCurrency }}
          </div>
        </v-col>

        <v-col cols="2">
          <div>
            <b>Pago:</b>
            <br/>
            {{ totalPago | formatCurrency }}
          </div>
        </v-col>

        <v-col cols="2">
          <div>
            <b>Glosado:</b>
            <br/>
            {{ totalGlosado | formatCurrency }}
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="hasSelectedItems" class="d-flex justify-center" cols="3">
      <v-btn
        v-if="selectedFaturamentoLotes.some(lote => lote.hasBaixa)"
        @click="() => $emit('action:desfazer-baixa-lotes')"
        :loading="loadingDesassociarLotes"
        color="primary"
        class="mr-2"
        :disabled="disableAcoesPagamento"
        small
        outlined
      >
        Desfazer
      </v-btn>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on">
            <v-btn
              @click="() => $emit('action:baixa-lotes')"
              :loading="loadingBaixaLotes"
              color="primary"
              :disabled="disableAcoes"
              small
              filled
              v-bind="attrs"
            >
              Baixa
            </v-btn>
          </div>
        </template>
        <span class="pa-5" v-if="disableAcoes">{{ this.mensagemTooltip }}</span>
      </v-tooltip>
    </v-col>
  </v-toolbar>
</template>

<script>
import { formatCurrency } from '../../../libs'

export default {
  props: {
    selectedFaturamentoLotes: Array,
    totalFaturamentoLotes: Number,
    loadingBaixaLotes: Boolean,
    loadingDesassociarLotes: Boolean,
    statusCount: Object,
    disableValorPendente: Boolean,
    disablePagamentoPublicado: Boolean
  },
  computed: {
    selectedFaturamentoLotesCount () {
      return this.selectedFaturamentoLotes.length
    },
    selectedAll () {
      return this.selectedFaturamentoLotesCount > 0 && this.selectedFaturamentoLotesCount === this.totalFaturamentoLotes
    },
    indeterminate () {
      return this.selectedFaturamentoLotesCount > 0 && this.selectedFaturamentoLotesCount < this.totalFaturamentoLotes
    },
    disabled () {
      return this.totalFaturamentoLotes === 0
    },
    label () {
      return this.selectedFaturamentoLotesCount === 0 ? 'Selecionar todos os lotes' : undefined
    },
    hasSelectedItems () {
      return this.selectedFaturamentoLotesCount > 0
    },
    cronogramas () {
      const cronogramas = this.selectedFaturamentoLotes.map(lote => lote.cronograma.dataFaturamento)

      return [...new Set(cronogramas)]
        .map(cronograma => this.$options.filters.formatDate(cronograma))
        .join(', ')
    },
    totalPendente () {
      return this.selectedFaturamentoLotes.reduce((total, faturamento) => total + (faturamento.valorTotal - faturamento.valorPagoConciliacaoItens), 0)
    },
    totalPago () {
      return this.selectedFaturamentoLotes.reduce((total, faturamento) => total + faturamento.valorPagoConciliacaoItens, 0)
    },
    totalGlosado () {
      return this.selectedFaturamentoLotes.reduce((total, faturamento) => total + faturamento.valorGlosadoConciliacaoItens, 0)
    },
    disableStatusCount () {
      return 'conciliacaoManual' in this.statusCount || 'conciliacaoAutomatica' in this.statusCount
    },
    disableAcoes () {
      return this.disableStatusCount || this.disablePagamentoPublicado || this.disableValorPendente
    },
    mensagemTooltip () {
      if (this.disablePagamentoPublicado) {
        return 'Pagamento já publicado'
      } else if (this.disableStatusCount) {
        return 'Pagamento em conciliacao Manual ou Automatica'
      } else if (this.disableValorPendente) {
        return 'Valores pendentes divergentes'
      }
      return ''
    }
  },
  methods: {
    handleFaturamentoCheckboxClick (checked) {
      if (checked) {
        this.$emit('change:select-all')
      } else {
        this.$emit('change:deselect-all')
      }
    }
  },
  filters: {
    pluralize (count) {
      if (count === 0) {
        return 'Nenhum lote selecionado'
      } else if (count === 1) {
        return '1 lote selecionado'
      } else {
        return `${count} lotes selecionados`
      }
    },
    formatCurrency (value) {
      return formatCurrency(value)
    }
  }
}
</script>
